
import React from 'react';
import { HotelCard } from './HotelCard';
import { Hotel } from '@/hooks/hotels/useHotelsList';

interface HotelGridProps {
  hotels: Hotel[];
  onRemove: (id: string) => void;
  onEdit: (id: string) => void;
}

export const HotelGrid: React.FC<HotelGridProps> = ({ hotels, onRemove, onEdit }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold">Your Hotels</h3>
      {hotels.length === 0 ? (
        <p className="text-muted-foreground text-center py-4">No hotels added yet</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {hotels.map((hotel) => (
            <HotelCard 
              key={hotel.id}
              hotel={hotel}
              onRemove={onRemove}
              onEdit={onEdit}
            />
          ))}
        </div>
      )}
    </div>
  );
};
